import ReactModal from "react-modal";
import { twMerge } from "tailwind-merge";

interface MessageModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  title?: string;
  shouldCloseOnOverlayClick?: boolean;
  showCloseButton?: boolean;
}

const MessageModal = ({
  isOpen,
  onRequestClose,
  children,
  className,
  overlayClassName,
  title,
  shouldCloseOnOverlayClick = false,
  showCloseButton = false,
}: MessageModalProps) => {
  return (
    <ReactModal
      appElement={document.getElementById("root") || undefined}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      className={twMerge(
        "relative p-6 mx-auto w-full max-w-sm bg-white rounded-2xl shadow-lg outline-none",
        className
      )}
      overlayClassName={twMerge(
        "fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50",
        overlayClassName
      )}
    >
      {showCloseButton && (
        <div className="absolute top-2 right-2 z-10">
          <button
            onClick={onRequestClose}
            className="flex justify-center items-center w-6 h-6 text-gray-400 bg-white rounded-full border border-gray-200 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      )}
      <h2 className="m-2 text-lg font-bold text-center">{title}</h2>
      {children}
    </ReactModal>
  );
};

export default MessageModal;
